import useDownloadHandler from '../../../src/hooks/useDownloadHandler';
import SetupHead from '../../../components/HowToSetup/SetupHead';
import React from 'react';
import App from '../../../components/App/App';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const HowToSetupPage = () => {
  useDownloadHandler();

  return (
    <App>
      <div className="content">
        <SetupHead />
      </div>
    </App>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default HowToSetupPage;
